import React, { Component } from "react";
import "./pillcard.css";
import ok from "../icons/ok.png";
import delet from "../icons/delete.png";
import down from "../icons/arrow-downward.svg";
import up from "../icons/arrow-upward.svg";
import block from "../icons/block.svg";
import person from "../icons/person.svg";
import noimage from '../icons/No_image_available.svg';
import EditDialog from '../NavBar/EditDialog';
import bullet from '../icons/bullet.svg';
import Appbar from '../NavBar/Appbar';
import Carousel from "nuka-carousel";
import { FormHelperText } from "@material-ui/core";
import { string } from "prop-types";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';

import effect1 from '../icons/effect_rare.png';
import effect2 from '../icons/effect_uncommon.png';
import effect3 from '../icons/effect_common.png';
import effect4 from '../icons/effect_very_common.png';

import goodrx from '../icons/goodrx.png';

import costco from '../icons/costco_logo.png';
import cvs from '../icons/cvs_logo.png';
import walmart from '../icons/walmart_logo.png';


//Adds the up or down symbol to the table according to the diferencia value
const commonalityGenerate = (side_effect_stats, language) => {
  let commonality = "";
  let common_css = "";
  if (isNaN(side_effect_stats)) {
    language === "eng"
      ? (commonality = "Unknown Frequency")
      : (commonality = "Frecuencia Desconocida");
    common_css = "unknown-commonality";
  } else if (side_effect_stats <= 1) {
    language === "eng"
      ? (commonality = "Very Uncommon")
      : (commonality = "Muy Raro");
    common_css = "v-uncommon-commonality";
  } else if (side_effect_stats < 10) {
    language === "eng" ? (commonality = "Uncommon") : (commonality = "Raro");
    common_css = "uncommon-commonality";
  } else {
    language === "eng" ? (commonality = "Common") : (commonality = "Común");
    common_css = "common-commonality";
  }

  return (
    <div className="commonality">
      <div className={common_css}>{commonality}</div>
      {isNaN(side_effect_stats) ? (
        ""
      ) : (
        <div className="side-effect-show">
          {side_effect_stats} out of 100{" "}
          <img className="person" src={person} alt="" />
        </div>
      )}
    </div>
  );
};

// const weightEffectGenerate = (weightEffect, language) => {
//   let w_title = "Weight Effect";
//   language === "eng"
//     ? (w_title = "Weight Effect")
//     : (w_title = "Efecto de Peso");
//   let w_eff = "";
//   let common_css = "";
//   if (weightEffect === "") {
//     language === "eng" ? (w_eff = "N/A") : (w_eff = "N/A");
//     common_css = "unknown-weight";
//   } else if (weightEffect === "Loss") {
//     language === "eng" ? (w_eff = weightEffect) : (w_eff = "Pérdida");
//     common_css = "uncommon-weight";
//   } else if (weightEffect === "Neutral") {
//     w_eff = weightEffect;
//     common_css = "v-uncommon-weight";
//   } else {
//     language === "eng" ? (w_eff = weightEffect) : (w_eff = "Aumento");
//     common_css = "common-weight";
//   }

//   return (
//     <div className="weight-effect-container center-children">
//       <div className="content-header">{w_title}</div>
//       <div className="weight-eff">
//         <div className={common_css}>{w_eff}</div>
//       </div>
//     </div>
//   );
// };
const generateImage = (effectnum) => {
  let imagesrc; 
  if (effectnum === "0"){
    imagesrc = "";
  }
  else if (effectnum === "1"){
    return (<img src={effect1} style={{width: 200, height: "auto", marginTop: 5}}/>);
  }
  else if (effectnum === "2"){
    return (<img src={effect2} style={{width: 200, height: "auto", marginTop: 5}} />);
  }
  else if (effectnum === "3"){
    return (<img src={effect3} style={{width: 200, height: "auto", marginTop: 5}} />);
  }
  else if (effectnum === "4"){
    return (<img src={effect4} style={{width: 200, height: "auto", marginTop: 5}} />);
  }
}

const generateWeightSedationEffect = (weightEffect, sedationEffect, language) => {
  return (
    <div>
      <Grid container>
        <Grid item style={{width: 75}}>
          <div className="font-comfortaa" style={{textAlign:"right"}}>
            <div style={{marginTop: 35, fontSize: "11px", marginLeft: 0, marginRight: 0}}>
              Weight Gain:
            </div>
          </div>

          <div className="font-comfortaa" style={{textAlign:"right"}}>
            <div style={{fontSize: "11px", marginTop: 10}}>
              Sedation:
            </div>
          </div>
        </Grid>

        
        <Grid item style={{width: 55, marginLeft: 15}}>
          <Grid container alignItems="flex-end" style={{width: 250}}>
            <Grid item style={{width: 40}}>
              <div style={{fontSize: "11px"}}>
                Rare
              </div>
            </Grid>
            <Grid item style={{width: 65}}>
              <div style={{fontSize: "11px"}}>
                Uncommon
              </div>
            </Grid>
            <Grid item style={{width: 55}}>
              <div style={{fontSize: "11px"}}>
                Common
              </div>
            </Grid>
            <Grid item style={{width: 65}}>
              <div style={{fontSize: "11px"}}>
                Very Common
              </div>
            </Grid>
          </Grid>
          {
            generateImage(weightEffect) //weightEffect = 1,2,3,4, or 0
          }
          
          {
            generateImage(sedationEffect) //sedationEffect = 1,2,3,4, or 0
          }
          </Grid>
    </Grid>
    </div>
  );
}

// hash string into hex code for pill card header color
String.prototype.getHashCode = function() {
  var hash = 0;
  if (this.length === 0) return hash;
  for (var i = 0; i < this.length; i++) {
    hash = this.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
};

Number.prototype.intToHSL = function() {
  var shortened = this % 360;
  return "hsl(" + shortened + ",85%,90%)";
};

const ColorButton = withStyles(theme => ({
  root: {
    color: theme.palette.getContrastText(blue[600]),
    backgroundColor: blue[600],
    '&:hover': {
      backgroundColor: blue[700],
    },
  },
}))(Button);

const generateGoodrxLink = (pillcardobj) => {
  return "https://www.goodrx.com/" + pillcardobj.Med_Name_Generic;
}

const generatePrice = (
  pillcardobj,
  VA_Covered,
  Medicaid_Covered,
  Low_cost_options,
  avg_cost,
  cost,
  costIndex,
  language,
  toggleCostHandler
) => {
  let costTitles = {"medicaid":"CT Medicaid", "prices":"", "va_formulary":"VA Formulary"};
  let buttonTitles = {"medicaid":"Medicaid", "prices":"Prices", "va_formulary":"VA Form"};
  let price = "N/A";
  let priceType = "";
  let switchToType = "";
  let currCostType = cost[costIndex];
  if (currCostType == "medicaid") {
    price = Medicaid_Covered ? <img className='pricesymbol' src={ok}/> : <img className='pricesymbol' src={delet}/>;
    priceType = costTitles[currCostType];
  } else if (currCostType == "va_formulary"){
    price = VA_Covered ? <img className='pricesymbol' src={ok}/> : <img className='pricesymbol' src={delet}/>;
    priceType = costTitles[currCostType];
  } else if (Low_cost_options) {
    price = "$4";
    priceType = Low_cost_options.split("/").join(", ");
  } else {
    price = 
      // <Grid container>
      //   <Grid item class='price-logos'>
      //     <div>
      //       <img src={costco} class="price-logo"/>
      //     </div>
          
      //     <div>
      //       <img src={cvs} class="price-logo"/>
      //     </div>

      //     <div>
      //       <img src={walmart} class="price-logo"/>
      //     </div>
      //   </Grid>
        
      //   <Grid item class='price-prices'>
      //     <div class='price-price'>$3.99</div>
      //     <div class='price-price'>$5.98</div>
      //     <div class='price-price'>$6.99</div>
      //   </Grid>

      //   <Grid item class="price-other">
      //     <div>
      //       <a href={generateGoodrxLink(pillcardobj)}>
      //         <ColorButton variant="contained" size="small" color="primary">
      //           <div className="font-comfortaa">
      //             GoodRx
      //           </div>
      //         </ColorButton>
      //       </a>
              
      //       <div className="price-other-text">

      //         <span>*Lowest</span>
      //         <span className="color-blue"> {" "}25 mg/30 tablets {" "}</span>
      //         <span>for New Haven, CT</span> 

      //       </div>
      //     </div>
      //   </Grid>
      // </Grid>
        <Grid container>
          <Grid item>
            <div className="good-rx">
            <div className="goodrx-content">
              <span>
                <img className="goodrx-logo" src={goodrx} />
              </span>
              <span className="goodrx-button">
                <a href={generateGoodrxLink(pillcardobj)}>
                 <ColorButton variant="contained" size="small" color="primary">
                   <div className="font-comfortaa">
                     Open
                   </div>
                 </ColorButton>
                </a>
              </span>
            </div>
            <div className="goodrx-text">
              {`*New tab to GoodRX`}
            </div>
            </div>
          </Grid>
        </Grid>
    language === "eng"
        ? (priceType = "Thirty Tablets Retail")
        : (priceType = "thirty tabs spanish");
    priceType = costTitles[currCostType];
    }
    costIndex = costIndex ^ 1
    switchToType = cost[costIndex];

  return (
    <div className="pill-price center-children">
      <div className="content-header price-content-header font-comfortaa" style={{"text-align" : "center"}}>
        {costTitles[currCostType]}
      </div>
      <div className="price">
        {price}
      </div>
    </div>
  );
};

const generateFrequencyButton = (pillcardobj, updatePillcardObjectHandler) => {
  return (
    <div className="content-header">
      <div class="edit-button" >
        <EditDialog fieldName={"Frequency"} pill={pillcardobj} updatePillcardObjectHandler={updatePillcardObjectHandler}/>
      </div>
    </div>
  )
}

const generateSpecialNotesButton = (pillcardobj, updatePillcardObjectHandler) => {
  return (
    <div className="content-header">
      <div class="edit-button" >
      <EditDialog 
         fieldName={"Special_Notes"} 
         pill={pillcardobj}
         updatePillcardObjectHandler={updatePillcardObjectHandler}
      />
      </div>
    </div>
  )
}


const generateSideEffectButton = (seIndex, language, toggleSideEffectHandler) => {
    let sideeffectTitlesEng = ["Severe", "Common"];
    let sideeffectTitlesSpan = ["severos", "comunes"];
  return (
    <div className="content-header" style={{"width" : "100px"}}>
      {/* <div className="content-header" style={{"text-align" : "center"}}>
        {language === "eng" ? sideeffectTitlesEng[seIndex] + " Side Effects" : "Efectos secundarios " + sideeffectTitlesSpan[seIndex]}
      </div> */}
      <div class="toggle-button-se" onClick={toggleSideEffectHandler}>
        {sideeffectTitlesEng[seIndex^1]}
      </div>
    </div>
  )
}

const generateMethodOfAction = (method, language) => {

  let method_desc;
  language === 'eng'
    ? method_desc = method["MethodOfAction"]["MethodOfActionName"]
    : method_desc = method["MethodOfAction"]["MethodOfActionNameES"]

  let qualifier = method["Verb"]
  let qual;
  if (qualifier === "up") {
    qual = <img className="method-qualifier" alt="up" src={up} />;
  } else if (qualifier === "down") {
    qual = <img className="method-qualifier" alt="down" src={down} />;
  } else if (qualifier === "blocks") {
    qual = <img className="method-qualifier" alt="blocks" src={block} />;
  }

  return (
    <div className="method-content">
      {qual} {method_desc}
    </div>
  );
};

const printFrequency = (frequency) => {
  return <div>{frequency}</div>
}

const generateFrequency = (pillcard, language) => {
  return <div className="freq-content font-comfortaa text-style">
  {language === "eng"
        ? pillcard.Frequency.split("/").map(printFrequency)
        : pillcard.Frequency_es.split("/").map(printFrequency)

  }</div>;
};

const generateOnsetOfAction = (pillcard, language) => {
  return <div className="onset-content font-comfortaa text-style">
  {language === "eng"
        ? pillcard.Onset_of_Action
        : pillcard.Onset_of_Action_es

  }
  </div>;
};

const generateAdditionalMonitoring = (add_mon) => {
    return (
        <div className="additional-monitoring-content">
            {add_mon}
        </div>
    );
}

const generateSpecialNotes = pillcard => {
  return <div className="special-content">
  {pillcard.Special_Notes}
  </div>;
};

const abbreviate = medclass => {
  var abv = medclass;
  switch (medclass) {
    case "Alpha-glucosidase Inhibitors":
      abv = "α-glucosidase Inhibitors";
      break;
    case "Calcium Channel Blockers - DHPs":
      abv = "CCBs - DHPs";
      break;
    case "Calcium Channel Blockers - Non DHPs":
      abv = "CCBs - Non DHPs";
      break;
    case "Aldosterone Antagonists":
      abv = "Aldost. Antag.";
      break;
    case "Potassium Sparing Diuretics":
      abv = "K-Sparing Diuretics";
      break;
    case "SRI + 5HT1A antagonist, partial 5HT1B, 5HT3, 5HT7":
      abv = "SRI+5HT1A antag. (5HT1B, 5HT3, 5HT7)"
    default:
      break;
  }
  if(abv.startsWith("Blank")) {
      abv = abv.substring(6);
      abv = abv.replace("_", " ");
  }
  return abv;
};

const printSideEffect = (sideeffect, language, type) => {
  //let name = sideeffect.substr(0, sideeffect.indexOf("("));
  let regExp = /\(([^)]+)\)/;
  let side_effect_stats = sideeffect[2];
    return (
      <div className="side-effect">
        <img src={bullet} style={{width: 8, height: "auto", marginRight: 20}}/>
        <div className="side-effect-name font-comfortaa" style={{"text-align": "left", fontSize: 15}}>{
          language === "eng"
          ? sideeffect[0]
          : sideeffect[1]
        }
          </div>
        {type == 'psychiatry' ? "" :
        <div className="side-effect-stats">
        {commonalityGenerate(sideeffect[2], language)}
        </div>}
      </div>
    );

};

const generateSideEffects = (sideEffectsCommon, sideEffectsSevere, type, seIndex) => {
    let common = [];
    let rare = [];
    for (let i = 0; i < sideEffectsCommon.length; i++) {
      if (type!='psychiatry') {
        common.push([sideEffectsCommon[i]["SideEffect_Common"]["SideEffectName"], sideEffectsCommon[i]["SideEffect_Common"]["SideEffectNameES"], sideEffectsCommon[i]["SideEffect_Common"]["Frequency_outof100"]]);
      } else {
        common.push([sideEffectsCommon[i]["SideEffect_Common"]["SideEffectName"], sideEffectsCommon[i]["SideEffect_Common"]["SideEffectNameES"], sideEffectsCommon[i]["SideEffect_Common"]["Frequency_outof100"], sideEffectsCommon[i]["SideEffect_Common"]["Priority"]]);
      }
    }
    for (let i = 0; i < sideEffectsSevere.length; i++) {
      rare.push([sideEffectsSevere[i]["SideEffect_Severe"]["SideEffectName"], sideEffectsSevere[i]["SideEffect_Severe"]["SideEffectNameES"], sideEffectsSevere[i]["SideEffect_Severe"]["Frequency_outof100"], sideEffectsSevere[i]["SideEffect_Severe"]["Priority"]]);
    }
    common.sort(function(a, b) {
    return a[1] - b[1];
    });
    rare.sort(function(a, b) {
    return a[1] - b[1];
    });

    if (seIndex == 0) {
      return rare;
    } else {
      return common;
    }
}

const generateWhatItTreats = (treatTypes, treatsIndex, treatDescriptions, language, toggleTreatsHandler) => {
  let treatTitles = "";
  if (language === "eng") {
    treatTitles = {"fda":"What it Treats (FDA):", "offlabel":"What it Treats (Off-Label)"};
  } else {
    treatTitles = {"fda":"Lo que trata (FDA):", "offlabel":"Lo que trata (Off-Label)"}
  }
  let title = "";
  let currTreatType = treatTypes[treatsIndex];
  let treatDescription = treatDescriptions[treatsIndex];
  title = treatTitles[currTreatType];
  return (
      <div>
      {/* <div className="content-header" style={{"text-align" : "center"}}>{title}</div> */}
      <div className="onset font-comfortaa text-style">{treatDescription}</div>
    </div>
  );
}

// const Decorators = [{
//     render() {
//       return (
//         <button
//           onClick={this.props.previousSlide}>
//           Previous Slide
//         </button>
//       )
//     },
//   position: 'CenterLeft',
//   style: {
//     padding: 20
//   }
// }];

const makeNukaCarousel = (image_urls) => {
  let imgarr = [];
  for (let i = 0; i < image_urls.length; i++){
      imgarr.push(
        <img className="pill-image" src={image_urls[i]["url"]} />
      )
  }
  
  return (
    <Carousel renderBottomCenterControls={null}>
      {imgarr}
    </Carousel>
  );
}


export default class Pillcard extends Component {
  removePillcardHandler = () => {
    this.props.removePillcardHandler(this.props.pillcardobj, true);
  };

  toggleCostHandler = () => {
    // if (this.props.cost == 'medicaid') {
    //   this.props.toggleTreatsHandler('avg');
    // } else {
    //   this.props.toggleTreatsHandler('medicaid');
    // }
    this.props.toggleCostHandler();
  };

  toggleTreatsHandler = () => {
    this.props.toggleTreatsHandler();
  };

  toggleSideEffectHandler = () => {
    this.props.toggleSideEffectHandler();
  };
  render() {
    let { pillcardobj, language, cost, costIndex, seIndex, treatsIndex, treatTypes, type } = this.props;
    let treatDescriptions = [pillcardobj.Treats_FDA_Approved, pillcardobj.Treats_Off_Label];
    return (
      <div>
        <div className="pillcard">
        {type === "addiction" ? (
          ""
        ) : (
          <div
            style={{
              "color": pillcardobj.Med_Class_Med_Class.getHashCode().intToHSL()
            }}
            className="pill-class font-comfortaa"
          >
            <div>
              <div className="medName font-comfortaa">{abbreviate(pillcardobj.Med_Class_Med_Class)}</div>
              <button
                class="close"
                onClick={this.removePillcardHandler}
                type="button"
              />
            </div>
          </div>
        )}
          <div className="head center-children">
            {pillcardobj.image_urls.length > 0 ?
                makeNukaCarousel(pillcardobj.image_urls)
                : <img className="pill-image" src={noimage} />
            }
            <span className="pill-name font-comfortaa">{pillcardobj.Med_Name_Generic}</span>
            <span className="pill-name-details font-comfortaa">{pillcardobj.Med_Name_Brand}</span>
          </div>
          <div className="content">
          {type === "psychiatry" ?
          <div className="center-children pill-treats-instruction">
                {generateWhatItTreats(
                  treatTypes,
                  treatsIndex,
                  treatDescriptions,
                  language,
                  this.toggleTreatsHandler
                )
              }
            </div>
        :""}
            <div className="center-children pill-freq">
              {/* <div className="content-header">
                {language === "eng" ? "When to Take:" : "Cuándo tomar"}
              </div> */}

              <div className="freq">
                <div>
                  {generateFrequencyButton(pillcardobj, this.props.updatePillcardObjectHandler)}
                </div>
              {
                  generateFrequency(pillcardobj, language)
                }
              </div>
            </div>

            <div className="pill-side-effects">
              {/* <div className="side-effect" style={{marginTop: 10}}>
                  <div>{generateSideEffectButton(seIndex, language, this.toggleSideEffectHandler)}</div>
              </div> */}
              {
                generateSideEffects(pillcardobj.Side_Effects_Common, pillcardobj.Side_Effects_Severe, type, seIndex).slice(0, 5).map(x =>
                  {
                    return printSideEffect(x, language, type);
                  }
                )
                  }
            </div>

            {/* <div className="pill-weight-effects">
              {generateWeightSedationEffect("1", "3", language)}
            </div> */}
              
            {type === "psychiatry"
            ?
            <div className="center-children pill-onset">
              {/* <div className="content-header">
                {language === "eng" ? "Time to effect" : "Tiempo antes del efecto"}:
              </div> */}
              <div className="onset">
              {
                  generateOnsetOfAction(pillcardobj, language)
                }
              </div>
            </div>
            :""}

            {generatePrice(
              pillcardobj,
              pillcardobj.VA_Covered,
              pillcardobj.Medicaid_Covered,
              pillcardobj.Low_cost_options,
              pillcardobj.Average_Cost,
              cost,
              costIndex,
              language,
              this.toggleCostHandler
            )}
            <div className="method-container center-children">
              {/* <div className="content-header">
                {language === "eng" ? "How it works" : "Cómo funciona"}:
                </div> */}
              <div className="font-comfortaa color-black">
                {
                  pillcardobj.Methods_of_Action
                    .slice(0, 3)
                    .map(x => {
                      return generateMethodOfAction(x, language);
                    })
                }
              </div>
            </div>
            {type === "psychiatry"
            ?
            <div className="center-children pill-onset">
              {/* <div className="content-header">
                {language === "eng" ? "Additional Monitoring" : "Monitoreo Adicional"}:
                </div> */}
                <div className="onset font-comfortaa color-black">
                    {language === "eng" ? pillcardobj.Additional_Monitoring : pillcardobj.Additional_Monitoring_es}
                </div>
              <div className="special">
                {language === "eng"}
              </div>
            </div>
           :""}
            {type === "psychiatry"
            ?
            <div className="center-children pill-special">
              {/* <div className="content-header">
                {language === "eng" ? "Special Notes" : "Notas Especiales"}:
              </div> */}
              <div className="special">
                <div>
                  {generateSpecialNotesButton(pillcardobj, this.props.updatePillcardObjectHandler)}

                </div>
                {
                  generateSpecialNotes(pillcardobj)
                }
              </div>
            </div>
           :""}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/CarouselElements/Pillcard.js